import { useLayoutEffect } from "react";
import { useProductCardHighlight } from "./ProductCardHighlightProvider";

export function useEqualHeightsOnHighlightChange(updateHeights: () => void, enabled = true) {
  const { highlightedCardId } = useProductCardHighlight();

  useLayoutEffect(() => {
    if (!enabled) return;
    updateHeights();
  }, [highlightedCardId, updateHeights, enabled]);
}
